<template>
  <div id="app">
    <keep-alive>
      <!--<router-view/>-->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
    name: 'App',

}
</script>

<style rel="stylesheet/css" lang="css" >
#app{
	height:100%;
	-webkit-box-flex: 1;
    box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.editIphone{
	height:100%;
	 background-color: #FFFFFF;
}

.userSubmit{
  height:100%;
  overflow-x: hidden;
	 background-color: #FFFFFF;
}

.logout {
    color: #20BDE5;
    font-size: 15px;
    display: block;
    text-align: center;
}

.font-default {
  color:#20BDE5!important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue